import { formatWeight } from '@zen/Cargo/helpers';
import { type CargoWeight, LooseCargoTypeEnum, SuggestionAttribute, type Volume } from '@zen/graphql/types.generated';
import { formatNumber } from '@zen/utils/formatting';

export const rejectReasons: string[] = ['The entered value matches the suggested value', 'The suggested value is not correct'];

export const extractProposedText = (proposedValue: string, suggestionAttribute: SuggestionAttribute): string => {
  switch (suggestionAttribute) {
    case SuggestionAttribute.CARGO_CONTAINER_NUMBER:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_DESCRIPTION:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_GROSS_WEIGHT:
      const cargoWeightSuggestion: CargoWeight = JSON.parse(proposedValue);

      return `${formatWeight(cargoWeightSuggestion)}`;

    case SuggestionAttribute.CARGO_LOOSE_CARGO_QUANTITY_AND_TYPE:
      const cargoLooseCargoQuantityAndTypeSuggestion: {
        quantity: number;
        type: LooseCargoTypeEnum;
      } = JSON.parse(proposedValue);

      const { quantity, type } = cargoLooseCargoQuantityAndTypeSuggestion;
      const cargoTypeLabel = enumToSentenceCase(type);

      return quantity ? `${quantity} x ${cargoTypeLabel}` : cargoTypeLabel;

    case SuggestionAttribute.CARGO_MARKS_AND_NUMBERS:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_SEAL_NUMBER:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_TARIFF_CODES:
      return JSON.parse(proposedValue);

    case SuggestionAttribute.CARGO_VOLUME:
      const cargoVolumeSuggestion: Volume = JSON.parse(proposedValue);

      return formatNumber(cargoVolumeSuggestion.value);

    case SuggestionAttribute.PRODUCT:
      return proposedValue;

    default:
      return proposedValue;
  }
};

export const enumToSentenceCase = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase());
};
